/**
 * Collapsed text block — animates the *closing* half of its <details>.
 * Markup: blocks/collapsed-text.php
 *
 * Opening already animates off the native [open] attribute via pure CSS
 * (group-open:… utilities in the block template) — no JS needed for that
 * direction. Closing doesn't: the browser hides a <details>'s content the
 * instant [open] is removed, before a transition gets a chance to run. So on
 * a close click this forces the row/chevron to their closed values via
 * inline style (which overrides the group-open: class rule while [open] is
 * still present), waits for that transition to actually finish, then removes
 * [open]. Without JS the block still opens/closes instantly via the native
 * attribute — this is a pure enhancement, not a dependency.
 */

const TRANSITION_FALLBACK = 400; // ms — safety net if transitionend never fires

function afterCollapse( content, done ) {
	let fired = false;
	const finish = () => {
		if ( fired ) {
			return;
		}
		fired = true;
		content.removeEventListener( 'transitionend', onEnd );
		done();
	};
	const onEnd = ( event ) => {
		if ( event.target === content && event.propertyName === 'grid-template-rows' ) {
			finish();
		}
	};
	content.addEventListener( 'transitionend', onEnd );
	setTimeout( finish, TRANSITION_FALLBACK );
}

document.querySelectorAll( '.block-collapsed_text details' ).forEach( ( details ) => {
	const summary = details.querySelector( ':scope > summary' );
	const content = details.querySelector( ':scope > .js-collapsed-text-content' );
	const chevron = details.querySelector( '.js-collapsed-text-chevron' );
	if ( ! summary || ! content ) {
		return;
	}

	summary.addEventListener( 'click', ( event ) => {
		if ( ! details.open ) {
			return; // opening — let the browser + CSS handle it natively
		}
		event.preventDefault();

		content.style.gridTemplateRows = '0fr';
		if ( chevron ) {
			chevron.style.rotate = '0deg'; // Tailwind's rotate-* utilities set the standalone `rotate` property, not `transform`
		}

		afterCollapse( content, () => {
			details.open = false;
			content.style.gridTemplateRows = '';
			if ( chevron ) {
				chevron.style.rotate = '';
			}
		} );
	} );
} );
